var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-wrapper-scroll-y"},[_c('b-table',{attrs:{"items":_vm.versions,"fields":_vm.fields},scopedSlots:_vm._u([{key:"versionDate",fn:function(ref){
var value = ref.value;
return [_c('div',[_vm._v(_vm._s(_vm._f("moment")(value,'DD/MM/Y')))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm._f("moment")(value,'HH:mm')))])]}},{key:"workOrderDate",fn:function(ref){
var value = ref.value;
return [_vm._v("\n      "+_vm._s(_vm._f("moment")(value,'DD/MM/Y'))+"\n    ")]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15ba8cd8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workOrderVersion/WorkOrderVersionTable.vue
// module id = null
// module chunks = 